// Feature Names for the feature flags
export const Features = {
  ASIN_EXPLORER_ANNOTATIONS: 'fflag.cobalt.asinExplorer.annotations',
  CLIENT_TESTING_LD: 'fflag.client.testingLd',
  COBALT_HIDE_EDIT_SEGMENTS: 'fflag.cobalt.hideEditSegments',
  COBALT_MAP_ALERTS: 'fflag.cobalt.mapAlerts',
  COBALT_MONTHLY_ASIN_LIMITS: 'fflag.cobalt.monthlyAsinLimits',
  COBALT_STATIC_SEGMENT: 'fflag.cobalt.staticSegment',
  COBALT_ASIN_EXPLORER_MAY_2020_TOOLTIP:
    'fflag.cobalt.asinExplorer.may2020Tooltip',
  COBALT_SHARE_AND_TRENDS_BRANDS_TABLE_V2:
    'fflag.cobalt.shareTrends.brandsTable.V2',
  COBALT_SHARE_AND_TRENDS_BRANDS_TABLE_ADDITIONAL_COLUMNS:
    'fflag.cobalt.shareTrends.brandsTable.additionalColumns',
  COBALT_SHARE_AND_TRENDS_3P_SELLER: 'fflag.cobalt.shareTrends.3pSeller',
  COBALT_SHARE_AND_TRENDS_3P_SELLER_EXCEL_EXPORT:
    'fflag.cobalt.shareTrends.3pSeller.excelExport',
  COBALT_SHARE_AND_TRENDS_TOKENIZATION: 'fflag.cobalt.shareTrends.tokenization',
  COBALT_TOLKIEN_PHASE_1: 'fflag.cobalt.tolkien.phase1',
  DASHBOARD_INSIGHTS: 'fflag.dashboard.insights',
  DASHBOARD_INSIGHTS_1: 'fflag.dashboard.insights1',
  EXTENSION_FEATURE_LIMITS: 'fflag.extension.featureLimits',
  KEYWORD_MOVE_LISTS_ITEMS_RESPONSE:
    'fflag.keywordTools.moveKeywordListItemsResponse',
  KEYWORD_LIST_API_SEARCH: 'fflag.keywordTools.keywordListApiSearch',
  KEYWORD_SEARCH_VOL_NEW_MODEL: 'fflag.keywordSearchVolume.newDataModelDate',
  LISTING_GRADER_LAUNCH: 'fflag.listingGrader.launch',
  MONEY_BACK_GUARANTEE: 'fflag.account.moneyBackGuarantee',
  PARTNER_STACK_UPGRADE_TO_V2: 'fflag.partnerStack.upgradeToV2',
  PPC_UNSYNC: 'fflag.ppc.unsync',
  PRODUCT_DATABASE_REDUCE_RESULTS: 'fflag.productDatabase.reduceResults',
  PRODUCT_DATABASE_DATE_FIRST_AVAILABLE_FILTER:
    'fflag.productDatabase.dateFirstAvailableFilter',
  PRODUCT_INSIGHTS_ASIN_EXPLORER_SHARED_BSR:
    'fflag.productInsights.asinExplorerSharedBsr',
  PRODUCT_INSIGHTS_PAGINATION: 'fflag.cobalt.productInsights.pagination',
  RANK_TRACKER_KEYWORDS_EXPORT: 'fflag.rankTracker.exportKeywords',
  REVIEW_ANALYSIS_POC: 'fflag.reviewAnalysis.poc',
  SALES_ESTIMATOR: 'fflag.salesEstimator',
  SALES_ANALYTICS_PRODUCT_TABLE: 'fflag.salesAnalytics.productTable',
  SEGMENT_BUILDER_SHARE_WITH_TEAM: 'fflag.segmentManager.shareWithTeam',
  SEGMENT_BUILDER_V2: 'fflag.cobalt.segmentBuilderV2',
  SEGMENT_BUILDER_V2_MODALS: 'fflag.cobalt.segmentBuilderV2Modals',
  SELLER_FEATURES_DISABLED: 'fflag.sellerFeatures.disabled',
  SHARE_OF_VOICE_HIDE_FEATURE: 'fflag.cobalt.shareOfVoice.hideFeature',
  SHARE_TRENDS_EXCEL_EXPORT: 'fflag.cobalt.shareTrends.excelExport',
  HIDE_EXCEL_EXPORT_BUTTON: 'fflag.cobalt.shareTrends.hideExcelExportButton',
  COBALT_WEEKLY_PROCESSING: 'fflag.cobalt.processing.weeklyprocessing.enabled',
  COBALT_IGNORE_NEW_ASINS: 'fflag.cobalt.processing.ignoreNewAsins.enabled',
  COBALT_SEGMENT_MANAGER_NEW_TOOLTIPS:
    'fflag.cobalt.segmentManager.newTooltips',
  COBALT_SEGMENT_MANAGER_CATEGORY_PARAM_MODAL:
    'fflag.cobalt.segmentManager.categoryParamModal',
  COBALT_SHARE_AND_TRENDS_SEGMENT_PAUSING_PHASE_1:
    'fflag.cobalt.shareTrends.segmentPausing.phase1',
  COBALT_SHARE_AND_TRENDS_ASIN_LIMITS_PHASE_2:
    'fflag.cobalt.shareTrends.ASINLimits.phase2',
  COBALT_SHARE_AND_TRENDS_UNIT_SALES_ROUNDING_DISABLED:
    'fflag.cobalt.shareTrends.segmentProductDay.disableRounding',
  COBALT_SHARE_AND_TRENDS_IN_APP_EXPORT: 'fflag.cobalt.shareTrends.inAppExport',
  COBALT_SHARE_AND_TRENDS_AUTO_ENFORCE_ASIN_LIMITS:
    'fflag.cobalt.shareTrends.autoEnforceASINLimits',
  UNBIND_ALIPAY_ENABLED: 'fflag.billingSettings.unbindAlipayEnabled',
  CN_THEME: 'fflag.cn.theme',
  LISTING_BUILDER_DISABLE_SYNC: 'fflag.listingBuilder.disableSync',
  NEW_SETUP_WIZARD: 'fflag.account.setupWizard',
  COBALT_GLOBAL_SEARCH_BETA: 'fflag.cobalt.globalSearch.beta',
  STRIPE_CUSTOMER_PORTAL: 'fflag.stripe.customerPortal',
  PRODUCT_SETTINGS_V2_CSV: 'fflag.productSettingsV2.csv',
  PRODUCT_SETTINGS_V2_TABLE: 'fflag.productSettingsV2.table',
  PRODUCT_SETTINGS_V2_BULK_ACTIONS: 'fflag.productSettingsV2.bulkActions'
}
